import { Component, Input } from '@angular/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

@Component({
  selector: 'app-weather-card',
  standalone: true,
  imports: [AnimateOnScrollDirective],
  templateUrl: './weather-card.component.html',
})
export class WeatherCardComponent {
  @Input() icon: string = '';
  @Input() value: string = '';
  @Input() label: string = '';
  @Input() iconColor: string = 'text-primary';
}
